/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
 import PRM from "@/core/PermissionConstants";
 import  RouteConstants from "@/app/core/RouteConstants";

export default {
  path: RouteConstants.AUDIOMETRY_PENDING.path,
  name: RouteConstants.AUDIOMETRY_PENDING.name,
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/AudiometryPendingService"),
    table: () => import("@/app/components/audiometry/pending/AudiometryPendingTable"),
    form: () => import("@/app/components/audiometry/pending/AudiometryPendingForm"),

    header: {
      icono: "mdi-ear-hearing",
      texto: "Consultas pendientes | Audiometría",
      textNew: "Atender Consulta | Audiometría",
      textEdit: "Editar Consulta | Audiometría",
      textView: "Visualizar consulta | Audiometría"
    },
    prm: PRM.MODULE_AUDIOMETRY_PENDING,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: true,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    saveButton: "Finalizar Consulta",
    labelDate: "Seleccione fecha",
    namePDF: "Audiometría",
    module: "audiometria"
  },
};
